export const NAV_GROUPS = [
  {
    label: "Road Safety Audit 3D",
    href: "/road-safety-audit-3d",
    items: [
      {
        label: "123BIMLive",
        href: "/123bimlive",
        blurb: "Upload a LiDAR scan, get a road safety audit",
      },
      {
        label: "Road Safety Audit 3D",
        href: "/road-safety-audit-3d",
        blurb: "Find sight-distance failures before the crash",
      },
      {
        label: "Why road safety audits",
        href: "/road-safety-audit-3d/why-road-safety-audits",
        blurb: "Proactive safety without crash history",
      },
      {
        label: "Sight distance study",
        href: "/road-safety-audit-3d/sight-distance-study",
        blurb: "Michigan State University research",
      },
    ],
    feature: {
      eyebrow: "Case study",
      title: "Stopping sight distance across Utah, from annual LiDAR",
      href: "/case-studies/udot-rsa-3d",
      cta: "Read the case study",
      image: "/images/case-studies/udot-rsa-3d/hero",
    },
  },
  {
    label: "3D Visualization",
    href: "/3d-visualization",
    items: [
      {
        label: "What is 3D visualization",
        href: "/3d-visualization",
        blurb: "Your design, built in Unreal Engine",
      },
      {
        label: "Virtual Tour",
        href: "/123bim/virtual-tour",
        blurb: "Guided public engagement tours",
      },
      { label: "3D Modeling", href: "/123bim/3d-modeling", blurb: "From CAD design to 3D model" },
      {
        label: "Photorealism",
        href: "/123bim/photorealism",
        blurb: "Ray-traced stills and animations",
      },
    ],
    feature: {
      eyebrow: "Case study",
      title: "Three interchange designs, ready for the first public meeting",
      href: "/case-studies/i26-sc27-interchange",
      cta: "Read the case study",
      image: "/images/case-studies/i26-sc27-interchange/hero",
    },
  },
  {
    label: "Our Work",
    href: "/case-studies",
    items: [
      { label: "Case Studies", href: "/case-studies", blurb: "Results for DOTs and agencies" },
      { label: "Projects", href: "/projects", blurb: "Visualization portfolio" },
    ],
    feature: {
      eyebrow: "Case study",
      title: "65 miles of drive-through video for the Henderson Interchange",
      href: "/case-studies/henderson-interchange",
      cta: "Read the case study",
      image: "/images/case-studies/henderson-interchange/hero",
    },
  },
  {
    label: "Resources",
    href: "/resources",
    items: [
      { label: "Blog", href: "/blog", blurb: "Road safety and visualization articles" },
      { label: "Webinars", href: "/resources/webinars", blurb: "Recorded sessions" },
      {
        label: "Whitepapers",
        href: "/resources/whitepapers",
        blurb: "Downloads and qualifications",
      },
      { label: "Press", href: "/resources/press", blurb: "News and releases" },
    ],
    feature: {
      eyebrow: "Article",
      title: "Line of sight vs. sight distance",
      href: "/blog/line-of-sight-vs-sight-distance",
      cta: "Read the article",
      image: "/images/blog/line-of-sight-vs-sight-distance/hero",
    },
  },
  {
    label: "About",
    href: "/about",
    items: [
      { label: "About RDV", href: "/about", blurb: "Since 2005" },
      { label: "Team", href: "/about/team", blurb: "Leadership, sales and development" },
      {
        label: "Board of Directors",
        href: "/about/team#board",
        blurb: "Direction and new initiatives",
      },
      { label: "Clients", href: "/about/clients", blurb: "State DOTs, agencies and firms" },
      { label: "Testimonials", href: "/about/testimonials", blurb: "In their words" },
    ],
    feature: {
      eyebrow: "Clients",
      title: "State DOTs, cities, agencies and engineering firms",
      href: "/about/clients",
      cta: "See all clients",
      // White-on-transparent `-mono` logos (scripts/optimize-images.mjs), not photos.
      logos: [
        { src: "/images/clients/fdot", name: "Florida DOT" },
        { src: "/images/clients/massdot", name: "MassDOT" },
        { src: "/images/clients/utdot", name: "Utah DOT" },
        { src: "/images/clients/scdot", name: "South Carolina DOT" },
        { src: "/images/clients/penndot", name: "PennDOT" },
        { src: "/images/clients/nevada", name: "Nevada DOT" },
      ],
    },
  },
];

export const FOOTER_COLUMNS = [
  {
    heading: "Products",
    links: [
      { label: "123BIMLive", href: "/123bimlive" },
      { label: "Road Safety Audit 3D", href: "/road-safety-audit-3d" },
      { label: "Why road safety audits", href: "/road-safety-audit-3d/why-road-safety-audits" },
      { label: "3D Visualization", href: "/3d-visualization" },
      { label: "3D Modeling", href: "/123bim/3d-modeling" },
      { label: "Virtual Tour", href: "/123bim/virtual-tour" },
    ],
  },
  {
    heading: "Our Work",
    links: [
      { label: "Case Studies", href: "/case-studies" },
      { label: "Projects", href: "/projects" },
      { label: "Clients", href: "/about/clients" },
      { label: "Testimonials", href: "/about/testimonials" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Blog", href: "/blog" },
      { label: "Webinars", href: "/resources/webinars" },
      { label: "Whitepapers", href: "/resources/whitepapers" },
      { label: "Press", href: "/resources/press" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Team", href: "/about/team" },
      { label: "Contact", href: "/contact" },
      { label: "Request a demo", href: "/demo" },
    ],
  },
];
